<template>
  <div>
    <!-- <el-tabs v-model="currentTabIndex" class="tabs-list"> -->
    <!--      <el-tab-pane label="版权声明" name="first" class="tabs-content">-->
    <!--        <copyright></copyright>-->
    <!--      </el-tab-pane>-->
    <!-- <el-tab-pane label="代下声明" name="second" class="tabs-content">
        <download></download>
      </el-tab-pane>
    </el-tabs> -->

    <TabTitle title="代下声明" :isShowTips="false" />
    <div class="table-container"><download /></div>
  </div>
</template>

<script>
import copyright from "./module/copyright.vue";
import download from "./module/download.vue";
import TabTitle from "@/components/TabTitle.vue";
import {
  setToken,
  getTempUser,
  getToken,
  getNewUser,
} from "../../utils/storage";
export default {
  components: {
    copyright,
    download,
    TabTitle,
  },
  data() {
    return {
      currentTabIndex: "second",
    };
  },
  mounted() {
    // if (getNewUser() == 0) {
    //   this.$store.commit("updateShowBottum", true);
    //   this.$store.commit("updateShowPost", true);
    // }
  },
  methods: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tabs-content {
  border-radius: 4px;
  padding: 0 40px;
  margin-bottom: 10px;
  padding: 30px 40px;
}

.table-container {
  background-color: white;
  padding: 30px;
}
</style>
